module.exports = __webpack_public_path__ + "static/media/text-align-left-white.cf472c87.svg";